export function brightnessByColor(color) {
  const c = '' + color,
    isHEX = color.indexOf('#') == 0,
    isRGB = color.indexOf('rgb') == 0;
  let r = null;
  let g = null;
  let b = null;
  let m = null;

  if (isHEX) {
    m = c.substr(1).match(c.length == 7 ? /(\S{2})/g : /(\S{1})/g);
    if (m)
      (r = parseInt(m[0], 16)),
        (g = parseInt(m[1], 16)),
        (b = parseInt(m[2], 16));
  }

  if (isRGB) {
    m = c.match(/(\d+){3}/g);
    if (m) (r = m[0]), (g = m[1]), (b = m[2]);
  }
  if (r) return (r * 299 + g * 587 + b * 114) / 1000;
}

export function isBrightColor(color) {
  return brightnessByColor(color) >= 200;
}
